import React from 'react';
import './CustomCss.scss';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import TabDataDistributor from '../../Containers/TabDataDistributor';
import { Component } from 'react';
import { updateCurrentTabStatus, updateBotValue, highlightSearchedResult, blockUiFun, getSelectedBotData } from '../../Redux/Actions/uiActions';
import { bindActionCreators } from 'redux';
import CreatePopMenu from '../../Elements/Molecules/CreatePopMenu';
import PopOverMenu from '../../Elements/Atoms/PopOverMenu';
import SETTINGSBLACKICON from '../../../assets/icons/sideNavIcons/ic_settingsBlack.png';

class Settings extends Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
        this.selectedTab = this.props.location.pathname.split('/')[2];
        this.firstParam = this.props.location.pathname.split('/')[1];

        if(this.firstParam === 'bot-list') return;
        
        let tempArray = this.props.tabListArray.filter(elem => {
            return elem.toLowerCase().replace(/ /g, '').replace(/\//g, '') === this.selectedTab;
        });
        if (tempArray.length) {
            this.props.updateCurrentTabStatus(this.selectedTab);
        } else if (this.selectedTab === 'settings') {
            this.props.updateCurrentTabStatus(this.selectedTab);
        }
        else {
            alert('This is not a valid tab');
        }
        this.props.blockUiFun(true);
        this.props.getSelectedBotData(this.firstParam, () => {
            this.props.blockUiFun(false);
        }, () => {
            this.props.blockUiFun(false);
        });
    }

    getReadableName = (actualName) => {
        if (actualName) {
            const readableName = actualName.replace(/-|_|\//g, ' ');
            return readableName;
        }
    }

    inputUpdate = (e, element, parent) => {
        if (element.length) {
            let currentData = this.props.editableBotData;
            let value = e.target.value;
            if (typeof (currentData[parent][element]) === 'object') {
                currentData[parent][element][Object.keys(currentData[parent][element])[0]] = value;
            } else {
                currentData[parent][element] = value;
            }
            this.props.updateBotValue(currentData);
        } else {
            alert(`${element} can't be empty`);
        }
    }

    getConfDetails = (array) => {
        let tempConfString = '';
        for (let index = 0; index < array.length; index++) {
            tempConfString += array[index];
            if (index < (array.length - 1)) {
                tempConfString += ' > ';
            }
        }
        return tempConfString;
    }

    addInputType = (parent, tempdata) => {
        if (!tempdata) return;
        const tempdataKeysArray = Object.keys(tempdata);
        return tempdataKeysArray.map((element, i) => {
            let containerClassName = 'character-input-box';
            if (tempdata[element].toString().length < 11) {
                containerClassName = 'character-input-box field-size-xs';
            } else if (tempdata[element].toString().length < 22) {
                containerClassName = 'character-input-box field-size-sm';
            } else if (tempdata[element].toString().length < 45) {
                containerClassName = 'character-input-box field-size-md';
            } else if (tempdata[element].toString().length < 70) {
                containerClassName = 'character-input-box field-size-lg';
            } else {
                containerClassName = 'character-input-box field-size-xl';
            }
            if (typeof (tempdata[element]) === 'object') {
                // console.log(element);
                // if(element !== 'headers' && element !== 'ANALYTICS_TRACK') {

                // } else {
                return (Object.keys(tempdata[element]).map((elm, j) => {
                    const parentMatch = JSON.stringify([parent, element, elm]) === JSON.stringify(this.props.highlightSearchedData.parent);
                    const labelClassName = 'config-title' + (this.props.highlightSearchedData.parent && this.props.highlightSearchedData.parent.length && parentMatch ? ' highlighted' : '');
                    return (
                        <div className='config-input-block' key={j}>
                            {parentMatch ? this.addTempDivToScroll() : null}
                            <div className='config-label'>
                                <label className={labelClassName}>{this.getReadableName(elm)}</label>
                                <div className='more-options-btn-wrapper popover-inactive'>
                                    <PopOverMenu
                                        groupDesc={'NA'}
                                        groupType={'group'}
                                        groupConfDetails={this.getConfDetails([parent, element, elm])}
                                        groupTitle={elm}
                                        tempdata={tempdata}
                                        parent={[parent, element, elm]}
                                    />
                                </div>
                            </div>
                            <div className='config-input-area'>
                                <div className={containerClassName} key={i}>
                                    <input className='form-control character-input' type='text' placeholder='Type here...' autoComplete='off' defaultValue={tempdata[element][Object.keys(tempdata[element])[j]]} onChange={(e) => {
                                        this.inputUpdate(e, element, parent);
                                    }} onPaste={(e) => {
                                        this.inputUpdate(e, element, parent);
                                    }} />
                                </div>
                            </div>
                            {this.executeScroll()}
                        </div>
                    );
                })
                );
                // }
            } else {
                const parentMatch = JSON.stringify([parent, element]) === JSON.stringify(this.props.highlightSearchedData.parent);
                const labelClassName = 'config-title' + (this.props.highlightSearchedData.parent && this.props.highlightSearchedData.parent.length && parentMatch ? ' highlighted' : '');
                return (
                    <div className='config-input-block' key={i}>
                        {parentMatch ? this.addTempDivToScroll() : null}
                        <div className='config-label'>
                            <label className={labelClassName}>{this.getReadableName(element)}</label>
                            <div className='more-options-btn-wrapper popover-inactive'>
                                <PopOverMenu
                                    groupDesc={'NA'}
                                    groupType={'group'}
                                    groupConfDetails={this.getConfDetails([parent, element])}
                                    groupTitle={element}
                                    tempdata={tempdata}
                                    parent={[parent, element]}
                                />
                            </div>
                        </div>
                        <div className='config-input-area'>
                            <div className={containerClassName} key={i}>
                                <input className='form-control character-input' type='text' placeholder='Type here...' autoComplete='off' defaultValue={tempdata[element]} onChange={(e) => {
                                    this.inputUpdate(e, element, parent);
                                }} onPaste={(e) => {
                                    this.inputUpdate(e, element, parent);
                                }} />
                            </div>
                        </div>
                        {this.executeScroll()}
                    </div>
                );
            }
        });
    }

    addTempDivToScroll = () => {
        return (<div ref={searchedNode => this.searchedNode = searchedNode}></div>)
    }

    scrollToRef = (ref) => {
        ref.scrollIntoView();
        // this.props.highlightSearchedResult({});
    }

    executeScroll = () => {
        setTimeout(() => {
            if (this.searchedNode)
                this.scrollToRef(this.searchedNode)
        }, 200)
    };

    render() {
        const postOptionsParentMatch = this.props.highlightSearchedData.parent && this.props.highlightSearchedData.parent.length === 1 && this.props.highlightSearchedData.parent['POST_OPTIONS'];
        const optionsParentMatch = this.props.highlightSearchedData.parent && this.props.highlightSearchedData.parent.length === 1 && this.props.highlightSearchedData.parent['OPTIONS'];
        const postOptionsClassName = 'config-title' + (postOptionsParentMatch ? ' highlighted' : '');
        const optionsClassName = 'config-title' + (optionsParentMatch ? ' highlighted' : '');
        return (
            <>
                <div className='tab-title-wrapper'>
                    <div className='tab-title-icon-wrapper'>
                        <img src={SETTINGSBLACKICON} name='Settings' width='24px' height='24px' alt='Settings' />
                    </div>
                    <span className='tab-title-text' title='Settings'>Settings</span>
                </div>
                <div className='tab-pane fade active in show'>
                    <TabDataDistributor
                        tempdata={this.props.editableBotData.SETTINGS ? { data: this.props.editableBotData.SETTINGS, title: 'SETTINGS', parentArray: ['SETTINGS'], isGeneric: false } : {}}
                    />

                    <div className="vertical-divider"></div>

                    <div className='tab-section-wrapper'>
                        {postOptionsParentMatch ? this.addTempDivToScroll() : null}
                        <div className='container-fluid group-inputs-wrapper no-padding'>
                            <div className='config-group-block' key={0}>
                                <div className='config-label'>
                                    <label className={postOptionsClassName}>{this.getReadableName('POST_OPTIONS')}</label>
                                    <div className='more-options-btn-wrapper popover-inactive'>
                                        <PopOverMenu
                                            groupDesc={'NA'}
                                            groupType={'group'}
                                            groupConfDetails={this.getConfDetails(['POST_OPTIONS'])}
                                            groupTitle={'POST_OPTIONS'}
                                            tempdata={this.props.editableBotData.POST_OPTIONS}
                                            parent={['POST_OPTIONS']}
                                        />
                                    </div>
                                </div>
                                <div className='config-group-area'>
                                    <div className='config-inputs-wrapper'>
                                        {this.addInputType('POST_OPTIONS', this.props.editableBotData.POST_OPTIONS)}
                                    </div>
                                    <div className='icon-button-wrapper go-float-right'>
                                        <CreatePopMenu
                                            className='eb-icon-btn-style add-new-input'
                                            parentArray={['POST_OPTIONS']}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="vertical-divider"></div>

                    <div className='tab-section-wrapper'>
                        {optionsParentMatch ? this.addTempDivToScroll() : null}
                        <div className='container-fluid group-inputs-wrapper no-padding'>
                            <div className='config-group-block' key={0}>
                                <div className='config-label'>
                                    <label className={optionsClassName}>{this.getReadableName('OPTIONS')}</label>
                                    <div className='more-options-btn-wrapper popover-inactive'>
                                        <PopOverMenu
                                            groupDesc={'NA'}
                                            groupType={'group'}
                                            groupConfDetails={this.getConfDetails(['OPTIONS'])}
                                            groupTitle={'OPTIONS'}
                                            tempdata={this.props.editableBotData.POST_OPTIONS}
                                            parent={['OPTIONS']}
                                        />
                                    </div>
                                </div>
                                <div className='config-group-area'>
                                    <div className='config-inputs-wrapper'>
                                        {this.addInputType('OPTIONS', this.props.editableBotData.OPTIONS)}
                                    </div>
                                    <div className='icon-button-wrapper go-float-right'>
                                        <CreatePopMenu
                                            className='eb-icon-btn-style add-new-input'
                                            parentArray={['OPTIONS']}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.executeScroll()}
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        tabListArray: state.UiReducer && state.UiReducer.tabListArray && state.UiReducer.tabListArray.length ? state.UiReducer.tabListArray : [],
        selectedBotData: state.UiReducer && state.UiReducer.selectedBotData ? state.UiReducer.selectedBotData : false,
        editableBotData: state.UiReducer && state.UiReducer.editableBotData ? state.UiReducer.editableBotData : {},
        currentActiveTab: state.UiReducer && state.UiReducer.currentActiveTab ? state.UiReducer.currentActiveTab : 'chatbot',
        availableBotList: state.UiReducer && state.UiReducer.availableBotList ? state.UiReducer.availableBotList : [],
        highlightSearchedData: state.UiReducer && state.UiReducer.highlightSearchedData ? state.UiReducer.highlightSearchedData : {}
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        updateCurrentTabStatus,
        updateBotValue,
        highlightSearchedResult,
        blockUiFun,
        getSelectedBotData
    },
        dispatch
    );
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Settings));